import React, { useRef } from "react";
import { useGLTF, Outlines } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";

export default function Model(props) {
  const { nodes, materials } = useGLTF("/plots/04-Lumberyard.glb");
  const outlineThickness = .008

  let built = props.built
  const model = useRef()

  useFrame((state, delta) => {
    if(!built && model.current.scale.y < 1)
    {
      AnimateIn()
    }
    else
    {
      IdleAnimation()
    }
  })

  function AnimateIn() {
    model.current.scale.y += (1 - model.current.scale.y) / 10
    model.current.scale.x += (1 - model.current.scale.x) / 10
    model.current.scale.z += (1 - model.current.scale.z) / 10
    if(model.current.scale.y > .997)
    {
      model.current.scale.x = 1
      model.current.scale.y = 1
      model.current.scale.z = 1
      // console.log(model.current.scale)
    }
  }

  function IdleAnimation()
  {
    // console.log('idleAnimating')
  }
  
  return (
    <group {...props} dispose={null} ref={model} scale={[.7,.2,.7]}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube025.geometry}
        material={materials["02-BenchMetal2"]}
        position={[-0.207, 0.233, 0.038]}
        rotation={[0, 0.469, 1.538]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube112.geometry}
        material={materials["00-Base3.001"]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube149.geometry}
        material={materials["07-BuildingMatTan"]}
        position={[-0.615, 0.375, -0.182]}
        scale={0.878}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube368.geometry}
        material={materials["07-RoofWood"]}
        position={[-0.615, 0.868, -0.182]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube370.geometry}
        material={materials["02-BenchWood"]}
        position={[-0.345, 0.208, 0.029]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube394.geometry}
        material={materials["08-WoodRopes"]}
        position={[0.482, 0.333, 0.344]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube401.geometry}
        material={materials["02-BenchMetal"]}
        position={[-0.207, 0.233, 0.038]}
        rotation={[0, 0.469, 1.538]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube404.geometry}
        material={materials["07-WindowMat"]}
        position={[-0.341, 0.322, 0.029]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cylinder062.geometry}
        material={materials["07-LogWood"]}
        position={[0.483, 0.299, 0.475]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cylinder065.geometry}
        material={materials["01-TreeGreen1"]}
        position={[0.266, 0.543, -0.507]}
        rotation={[-Math.PI, 1.27, -Math.PI]}
        scale={1.08}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cylinder069.geometry}
        material={materials["01-TreeGreen2"]}
        position={[0.639, 0.543, -0.24]}
        rotation={[0, 1.206, 0]}
      ><Outlines thickness={outlineThickness}/></mesh>
    </group>
  );
}

useGLTF.preload("/plots/04-Lumberyard.glb");